export const  onlyBeUsed="This function can only be used when the taxpayer status is registered.";
export const  no="No. of Receipts";
export const  value="Value of Receipts";
export const  yearly="Yearly";
export const  monthly="Monthly";
export const  weekly="Weekly";
export const  daily="Daily";
export const  ok="OK";

export const  total="Total";
export const  vat="VAT";
export const  excise="Excise";
export const  other="Other";
export const  numberNotFound="The reference number was not found!";
export const  invoiceNotExist="The invoice does not exist";
export const  tooManyTimes="The invoice has been validated too many times, exceeding the maximum limit.";

export const  pendingTaskList="Pending Task List";
export const  creditNote="Credit Note";
export const  cancellationDebit="Cancellation of Debit Note";
export const  offlineParameters="Offline Parameters";
export const  myDashboard="My Dashboard";
export const  statisticsType="Statistics Type";
export const  invoicesIssued="Receipts/Invoices Issued";
export const  taxStatistics="Tax statistics";
export const  menuQuickEntry="Menu quick entry";
export const  trackApplicationStatus="Track Application Status";
export const  enterReferenceNumber="Enter Your Reference Number";
export const  fiscalDocumentValidation="Fiscal Document Validation";
export const  numberIsRequired="Invoice/Receipt Number is required";
export const  enterNumber="Enter Invoice/Receipt Number";
export const  enterDateIssued="Enter Date Issued";
export const  verificationCode="Verification Code";
export const  deviceNumber="Device Number";
export const  validate="Validate";
export const  track="Track";
export const  basicSearch="Basic Search";
export const  advancedSearch="Advanced Search";
export const  accreditedSuppliers="Accredited Suppliers";

export const  devices="Devices";
export const  softwareIntegrators="Software Integrators";
export const  zReports="Z-Reports";
export const  document="Document";
export const  dsn="DSN";
export const  applicationSoftware="Application Software";
export const  enterFiscalDocument="Enter Fiscal Document Number";
export const  salesInvoices="Sales Invoices";
export const  totalInvoiceQuantity ="Total Invoice Quantity";
export const  totalInvoiceAmount="Total Invoice Amount";
export const awaiting="Awaiting";
export const accepted="Accepted";
export const rejected="Rejected";
